module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loggedIn) ? _c('div', {
    staticClass: "dashboard"
  }, [_c('DashboardHeader', {
    attrs: {
      "menu-showing": _vm.menuShowing,
      "spinner-visible": _vm.spinnerVisible,
      "page-title": _vm.pageTitle,
      "page-icon": _vm.pageIcon,
      "bank-accounts": _vm.bankAccounts,
      "pages-meta": _vm.pagesMeta,
      "accountBalanceTotals": _vm.accountBalanceTotals,
      "is-offline": _vm.isOffline,
      "transactions-synced": _vm.transactionsSynced,
      "alert": _vm.alert
    },
    on: {
      "showModal": _vm.showTransactionModal,
      "navigate": _vm.navigate,
      "toggleMenu": function($event) {
        _vm.menuShowing ? _vm.menuShowing = false : _vm.menuShowing = true
      },
      "showAccountsModal": _vm.showAccountsModal,
      "showImportModal": function($event) {
        _vm.importModalVisible = true
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section-wrapper",
    class: {
      menuShowing: _vm.menuShowing
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [(_vm.currentRoute == '/categories') ? _c('CategoryManager', {
    attrs: {
      "groups": _vm.masterGroups
    },
    on: {
      "fetchGroups": _vm.fetchGroups,
      "alertUpdate": _vm.updateAlert
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentRoute == '/accounts') ? _c('AccountManager', {
    attrs: {
      "bank-accounts": _vm.bankAccounts
    },
    on: {
      "bankAccountsChange": _vm.fetchBankAccounts,
      "editAccount": _vm.showAccountsModal,
      "alertUpdate": _vm.updateAlert
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentRoute == '/users') ? _c('UserManager', {
    on: {
      "alertUpdate": _vm.updateAlert
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentRoute == '/transactions') ? _c('TransactionLog', {
    attrs: {
      "groups": _vm.masterGroups,
      "categories": _vm.masterCategories,
      "bank-accounts": _vm.bankAccounts,
      "is-offline": _vm.isOffline
    },
    on: {
      "showTransactionModal": _vm.showTransactionModal,
      "alertUpdate": _vm.updateAlert
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentRoute == '/' || _vm.currentRoute == '/budget') ? _c('BudgetManager', {
    attrs: {
      "master-groups": _vm.masterGroups,
      "accountBalanceTotals": _vm.accountBalanceTotals,
      "is-offline": _vm.isOffline
    },
    on: {
      "alertUpdate": _vm.updateAlert
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentRoute == '/clear-imported-transactions') ? _c('TransactionClearing', {
    attrs: {
      "bank-accounts": _vm.bankAccounts,
      "groups": _vm.masterGroups
    },
    on: {
      "alertUpdate": _vm.updateAlert
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentRoute == '/my-profile') ? _c('MyProfile', {
    on: {
      "alertUpdate": _vm.updateAlert
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('TransactionModal', {
    attrs: {
      "modal-visible": _vm.transactionModalVisible,
      "groups": _vm.masterGroups,
      "incomes": _vm.incomeSources,
      "field-data": _vm.transactionData,
      "bank-accounts": _vm.bankAccounts,
      "tran-type": "Transaction"
    },
    on: {
      "showModal": _vm.showTransactionModal,
      "closeModal": _vm.closeTransactionModal,
      "transactionSubmitted": _vm.refreshTransactionData,
      "isOffline": function($event) {
        _vm.isOffline = true
      },
      "isOnline": function($event) {
        _vm.isOffline = false
      }
    }
  }), _vm._v(" "), _c('ModalDialog', {
    attrs: {
      "title": "Add/Edit Bank Account",
      "modal-visible": _vm.accountModalVisible,
      "confirm-button-text": "Save"
    },
    on: {
      "confirm": _vm.saveBankAccount,
      "closeModal": function($event) {
        _vm.accountModalVisible = false
      }
    }
  }, [_c('FormGroup', {
    attrs: {
      "label": "Description",
      "col-class": "col-md-4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modalBankAccount.description),
      expression: "modalBankAccount.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.modalBankAccount.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.modalBankAccount.description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('FormGroup', {
    attrs: {
      "label": "",
      "col-class": "col-md-4"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modalBankAccount.off_budget),
      expression: "modalBankAccount.off_budget"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": 1,
      "false-value": 0
    },
    domProps: {
      "checked": Array.isArray(_vm.modalBankAccount.off_budget) ? _vm._i(_vm.modalBankAccount.off_budget, null) > -1 : _vm._q(_vm.modalBankAccount.off_budget, 1)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.modalBankAccount.off_budget,
          $$el = $event.target,
          $$c = $$el.checked ? (1) : (0);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.modalBankAccount.off_budget = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.modalBankAccount.off_budget = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.modalBankAccount.off_budget = $$c
        }
      }
    }
  }), _vm._v("\n\t\t\t\t\tAccount is Not Tracked in Budget\n\t\t\t\t")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('FormGroup', {
    attrs: {
      "label": "",
      "col-class": "col-md-4"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconcileAccount),
      expression: "reconcileAccount"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.reconcileAccount) ? _vm._i(_vm.reconcileAccount, null) > -1 : (_vm.reconcileAccount)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.reconcileAccount,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.reconcileAccount = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.reconcileAccount = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.reconcileAccount = $$c
        }
      }
    }
  }), _vm._v("\n\t\t\t\t\tReconcile Account\n\t\t\t\t")])]), _vm._v(" "), (_vm.reconcileAccount) ? _c('div', [_c('FormGroup', {
    attrs: {
      "label": "Reconciled",
      "col-class": "col-md-4"
    }
  }, [_c('DateField', {
    attrs: {
      "extra-classes": "form-control"
    },
    model: {
      value: (_vm.modalBankAccount.reconcile_date),
      callback: function($$v) {
        _vm.modalBankAccount.reconcile_date = $$v
      },
      expression: "modalBankAccount.reconcile_date"
    }
  })], 1), _vm._v(" "), _c('FormGroup', {
    attrs: {
      "label": "Reconciled Balance",
      "col-class": "col-md-4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modalBankAccount.reconcile_balance),
      expression: "modalBankAccount.reconcile_balance"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.modalBankAccount.reconcile_balance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.modalBankAccount.reconcile_balance = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('ModalDialog', {
    attrs: {
      "title": "Import CSV Transactions",
      "modal-visible": _vm.importModalVisible,
      "confirm-button-text": "Proceed to Import",
      "form-action": _vm.fileUpload.target,
      "form-enctype": "multipart/form-data",
      "submit-visible": _vm.fileUpload.submitVisible
    },
    on: {
      "confirm": _vm.beginTransactionImport,
      "closeModal": function($event) {
        _vm.importModalVisible = false
      }
    }
  }, [_c('div', {
    staticClass: "dropbox"
  }, [_c('fileupload', {
    staticClass: "input-file",
    attrs: {
      "target": _vm.fileUpload.target,
      "action": "POST",
      "accept": ".csv"
    },
    on: {
      "start": _vm.startUpload,
      "finish": _vm.finishUpload,
      "progress": _vm.uploadProgress
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t  " + _vm._s(_vm.fileUpload.msg) + "\n\t\t\t\t")])], 1), _vm._v(" "), _c('FormGroup', {
    attrs: {
      "label": "Formatting",
      "col-class": "col-md-4"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fileUpload.fileFormat),
      expression: "fileUpload.fileFormat"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fileUpload.fileFormat = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "CIBC"
    }
  }, [_vm._v("CIBC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RBC"
    }
  }, [_vm._v("RBC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PC Financial"
    }
  }, [_vm._v("PC Financial")])])]), _vm._v(" "), (_vm.importAlert.visible) ? _c('div', {
    staticClass: "alert",
    class: _vm.importAlert.class,
    domProps: {
      "innerHTML": _vm._s(_vm.importAlert.msg)
    }
  }) : _vm._e()], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c99d770"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/templates/Dashboard.vue
// module id = 156
// module chunks = 1